export default [
    {
        path: "/disposal",
        name: "Disposal",
        component: require("@/components/Disposal/DisposalListPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Disposal",
                },
            ]
        }
    },{
        path: "/disposal/create",
        name: "AddDisposal",
        component: require("@/components/Disposal/DisposalCreationPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Disposal",
                    path: '/disposal',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                // {
                //     name: "Product",
                //     path: '/catalog',
                //     query: {
                //         type: "All",
                //         typeName:"All",
                //         name: "",
                //         category: "All",
                //         categoryName: "All",
                //         status: "All",
                //         itemPerPage: 10,
                //         page: 1
                //     }
                // },
                {
                    name: "Buat Disposal Baru",
                }
            ]
        }
    },{
        path: "/disposal/:id",
        name: "DisposalDetail",
        component: require("@/components/Disposal/DisposalDetailPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Disposal",
                    path: '/disposal',
                    query: {
                        disposalId: '',
                        disposalDate: '',
                        createdBy: '',
                        erpTrxId: '',
                        jurnalTrxId: '',
                        status: '',
                        page: 1,
                        itemPerPage: 10,
                    }
                },
                {
                    name: "Detail Disposal",
                }
            ]
        },
        beforeEnter: (to, from, next) => {
            to.meta.breadcrumbs[1].name = to.query.code ? `Detail ${to.query.code}` : "Detail Disposal";
            next();
        }
    },

]


// WEBPACK FOOTER //
// ./src/router/disposal/index.js